<template>
    <h1>Página não encontrada</h1>
</template>

<script>
</script>

<style scoped lang="scss">
</style>